export default {
    contactSubTitle: 'Ambassade de France en Russie',
    contactText1: '',
    contactText2: 'Service des Bourses <br />' +
        '45, Bolchaïa Iakimanka - 115127 Moscou',
    contactText3: 'Tel : +7 (495) 937 15 14, +7 (495) 937 15 09, +7 (495) 937 24 97',
    contactText4: 'Par email : <br />' +
        '<a href="mailto:bgf.moscou-amba@diplomatie.gouv.fr">bgf.moscou-amba@diplomatie.gouv.fr</a>',
}